import httpClient from '../httpClient';

export async function getAllFornecedorComunicacoes() {
  try {
    const response = await httpClient.get(`/api/fornecedorcomunicacao`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}

export async function getComunicacoesByFornecedor(fornecedorId: string) {
  try {
    const response = await httpClient.get(
      `/api/fornecedorcomunicacao/fornecedor/${fornecedorId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter lista de Registros: ' + error);
  }
}
